import styled from "styled-components";

export const StyledTaskList = styled.div`
  margin: 20px;
  padding: 10px 0;
  width: 90vw;
  max-width: 400px;
  background-color: white;
  box-shadow: 0 0 1px grey;
  border-radius: 10px;
`;

export const StyledTaskListHeader = styled.div`
  display: flex;
  margin: 0 10px 20px 20px;
  justify-content: space-between;
  overflow-wrap: anywhere;
`;

export const StyledListHeading = styled.h2`
  margin-top: 10px;
`;
